export class callLogService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    getCallHistory() {
        const action = "getCallHistory";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = {
                client: "integration",
                action: "CallRecord"
            }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/callLogService.js